import React from 'react';
import { motion } from 'framer-motion';
export function TopBar() {
  return <div className="bg-zinc-900 border-b border-zinc-800 py-2 px-4 text-center z-50 relative" data-id="element-154">
      <div className="flex items-center justify-center gap-2 text-xs sm:text-sm font-medium text-amber-500 uppercase tracking-wider" data-id="element-155">
        <motion.div animate={{
        opacity: [1, 0.5, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="w-2 h-2 rounded-full bg-amber-500" data-id="element-156" />
        <span data-id="element-157">LIMITED RELEASE — Digital delivery in 5 minutes</span>
      </div>
    </div>;
}